function parseBooleanEnv(value: string | undefined): boolean | undefined {
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim().toLowerCase();
  if (!normalized) return undefined;
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  return undefined;
}

function resolveBooleanFlag(
  privateEnvKey: string,
  publicEnvKey: string,
  fallback: boolean,
): boolean {
  const privateFlag = parseBooleanEnv(process.env[privateEnvKey]);
  if (privateFlag !== undefined) return privateFlag;
  const publicFlag = parseBooleanEnv(process.env[publicEnvKey]);
  if (publicFlag !== undefined) return publicFlag;
  return fallback;
}

export function isAsyncResearchExportEnabledServer(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_ASYNC_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_ASYNC_EXPORTS_ENABLED',
    true,
  );
}

export function isGoogleWorkspaceExportDeliveryEnabledServer(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_GOOGLE_WORKSPACE_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_GOOGLE_WORKSPACE_EXPORTS_ENABLED',
    true,
  );
}

export function isGoogleSlidesExportEnabledServer(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_GOOGLE_SLIDES_EXPORT_ENABLED',
    'NEXT_PUBLIC_RESEARCH_GOOGLE_SLIDES_EXPORT_ENABLED',
    true,
  );
}

export function isInfographicExportEnabledServer(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_INFOGRAPHIC_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_INFOGRAPHIC_EXPORTS_ENABLED',
    true,
  );
}

export function isSlidesReportExportEnabledServer(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_SLIDES_REPORT_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_SLIDES_REPORT_EXPORTS_ENABLED',
    true,
  );
}

export function isRefinementExportEnabledServer(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_REFINEMENT_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_REFINEMENT_EXPORTS_ENABLED',
    true,
  );
}

export function isAsyncResearchExportEnabledClient(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_ASYNC_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_ASYNC_EXPORTS_ENABLED',
    true,
  );
}

export function isGoogleWorkspaceExportDeliveryEnabledClient(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_GOOGLE_WORKSPACE_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_GOOGLE_WORKSPACE_EXPORTS_ENABLED',
    true,
  );
}

export function isGoogleSlidesExportEnabledClient(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_GOOGLE_SLIDES_EXPORT_ENABLED',
    'NEXT_PUBLIC_RESEARCH_GOOGLE_SLIDES_EXPORT_ENABLED',
    true,
  );
}

export function isInfographicExportEnabledClient(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_INFOGRAPHIC_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_INFOGRAPHIC_EXPORTS_ENABLED',
    true,
  );
}

export function isSlidesReportExportEnabledClient(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_SLIDES_REPORT_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_SLIDES_REPORT_EXPORTS_ENABLED',
    true,
  );
}

export function isRefinementExportEnabledClient(): boolean {
  return resolveBooleanFlag(
    'RESEARCH_REFINEMENT_EXPORTS_ENABLED',
    'NEXT_PUBLIC_RESEARCH_REFINEMENT_EXPORTS_ENABLED',
    true,
  );
}
